import { AlertCircle, Box, Inbox, RefreshCw } from 'lucide-react';

export function PageLoading({
  label = 'Cargando información…',
}: Readonly<{ label?: string }>): React.JSX.Element {
  return (
    <div className="grid min-h-[280px] place-items-center rounded-2xl border border-slate-200 bg-white/75 p-8 shadow-sm">
      <div className="flex flex-col items-center gap-3 text-center">
        <span
          className="size-8 animate-spin rounded-full border-[3px] border-brand-100 border-t-brand-500"
          aria-hidden="true"
        />
        <p className="text-sm text-slate-500">{label}</p>
      </div>
    </div>
  );
}

export function PageError({
  title = 'No pudimos cargar esta información',
  description = 'Revisá tu conexión e intentá nuevamente.',
  onRetry,
}: Readonly<{
  title?: string;
  description?: string;
  onRetry?: () => void;
}>): React.JSX.Element {
  return (
    <div className="grid min-h-[280px] place-items-center rounded-2xl border border-rose-100 bg-white p-8 text-center shadow-sm">
      <div className="max-w-sm">
        <span className="mx-auto mb-4 grid size-11 place-items-center rounded-2xl bg-rose-50 text-rose-600">
          <AlertCircle size={22} aria-hidden="true" />
        </span>
        <h2 className="text-base font-semibold text-ink-950">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-5 inline-flex items-center gap-2 rounded-xl bg-ink-900 px-3.5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-ink-800"
          >
            <RefreshCw size={15} aria-hidden="true" />
            Reintentar
          </button>
        )}
      </div>
    </div>
  );
}

export function EmptyPanel({
  icon = 'inbox',
  title,
  description,
  action,
}: Readonly<{
  icon?: 'inbox' | 'box';
  title: string;
  description: string;
  action?: React.ReactNode;
}>): React.JSX.Element {
  const Icon = icon === 'box' ? Box : Inbox;
  return (
    <div className="grid min-h-[235px] place-items-center rounded-2xl border border-dashed border-slate-250 bg-white/70 px-6 py-10 text-center">
      <div className="max-w-sm">
        <span className="mx-auto mb-4 grid size-12 place-items-center rounded-2xl bg-slate-100 text-slate-500">
          <Icon size={23} aria-hidden="true" />
        </span>
        <h2 className="text-base font-semibold text-ink-950">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>
        {action && <div className="mt-5">{action}</div>}
      </div>
    </div>
  );
}
